<template>
<div id="cardApp" class="app-wrapper">
<!-- 无 token 时显示拒绝访问页面 -->
<div v-if="!tokenValid && !loading" class="access-denied">
<div class="denied-content">
<h1>⚠️ Access Denied</h1>
<p>Invalid or missing token. Please contact administrator.</p>
<el-button @click="goHome">Return to Home</el-button>
</div>
</div>

<!-- 有 token 时显示正常页面 -->
<div v-else-if="tokenValid" class="main-wrapper">
<main class="content-main">
<img src="@/assets/hktcmbanner.jpg" style="width:100%" />
<img src="@/assets/hktcmbg.jpg" style="width:100%" />
<div class="page-title-row" style="display: flex; justify-content: space-between; align-items: center;">
<h3 style="margin: 0;">Prepaid Card Application</h3>
</div>

<div class="apply-section">
<!-- 主卡申请入口 -->
<div class="apply-item">
<div class="apply-info">
<div class="apply-title">Primary Card Application</div>
<div class="apply-desc">Apply for your own HKTCM Global Visa Prepaid Card.</div>
</div>
<div class="apply-btn apply-btn-primary" @click="startApplication('primary')">Apply Primary Card</div>
</div>
  
<!-- 附属卡申请入口 -->
<div class="apply-item">
<div class="apply-info">
<div class="apply-title">Supplementary Card Application</div>
<div class="apply-desc">Apply for a supplementary card for family members or employees.</div>
</div>
<div class="apply-btn apply-btn-secondary" @click="startApplication('supplementary')">Apply Supp. Card</div>
</div>
</div>

<div style="margin-top: 20px; padding: 15px; background: #f8f9fa; border-radius: 8px; font-size: 13px; color: #666;">
Online applications are not processed immediately and should not be used for urgent submissions. For any inquiries, please contact us promptly via email.
</div>
</main>

<!-- 条款及细则弹窗 -->
<el-dialog :visible.sync="termsVisible" title="Terms and Conditions" width="850px" class="terms-dialog" :close-on-click-modal="false">
<div class="terms-header">HKTCM Global Visa Prepaid Card Terms and Conditions</div>
<div class="terms-content" ref="termsContentRef" @scroll="handleTermsScroll">
<p><strong>Important Notice! These Terms andConditions may regulate your use of the HKTCM Global VISA Prepaid  Card  (hereinafter referred to as “Prepaid Card”)arranged or facilitated by Hong Kong Trust Capital Management Limited (HKTCM) (the ‘Company’, ‘we’,“us” or ‘our’) and its partners. Please read these Terms and Conditionscarefully before using the Prepaid Card. Your use (including activation) of the Prepaid Cardshall be deemed to constitute your acceptance of and agreement to be bound bythese Terms and Conditions. Definitions of terms used in these Terms andConditions are set out at the end of these Terms and Conditions.</strong></p>
<p><strong>Qualifications and Registration</strong></p>
<p>1.We reserve the right to take the following actions at any time:<br>
a)Modify, update, or alter these terms and conditions; or<br>
b)Charges, fees, or other conditions may apply for the use of this service or any part thereof (subject to reasonable advance notice).<br>
(All of the above shall collectively be referred to as the "Amendments").</p>
<p>2. We may modify these Terms at any time without notice (except as otherwise provided in paragraph (b) above). Any changes to these Terms may be posted on our website or notified to you via email using the email address provided in your account. Therefore, you should regularly review our website, enable receipt of such push notifications, and ensure the email address and other contact information in your account remain up to date. Your continued use of the Services after such changes take effect constitutes your acceptance of those changes.</p>
<p>3.You must:<br>
a)  Existing trust clients of the Company with account assets meeting the corresponding tier threshold.<br>
b)  Have reached the legal age and possess the capacity to enter into contracts under applicable law.<br>
c)	Reside in a jurisdiction determined by the Company and its partners to be eligible for card issuance.<br>
d)  Comply with all applicable laws, including Anti-Money Laundering (AML) and Know Your Customer (KYC) requirements.<br>
e)  Provide all verification and identity documents as requested by the Company or its partners.</p>
<p>4.You agree to ensure that your registration information is accurate and updated in a timely manner. Failure to do so may result in the suspension or termination of your service access privileges.</p>
<p>5.The company reserves the right to modify, suspend, or terminate your access to the services at any time and at its sole discretion.</p>
<p><strong>Regarding the Prepaid Card</strong></p>
<p>6.This card is a prepaid card. Your card account is not a checking orsavings account and is not linked to any other account you hold, except forcash sub-accounts within trust accounts. This card is not a gift card andcannot be given to others. This card is not a prepaid card, so you may not havethe same rights associated with prepaid card transactions. Funds in your cardaccount do not earn interest.</p>
<p>7.You may access your account balance through your prepaid card. Youshall be subject from time to time to these Terms and Conditions and otherterms governing your account and the applicable payment network or platform. Inthe event of any inconsistency between these Terms and other terms, these Termsand Conditions shall prevail in relation to your prepaid card and any services.</p>
<p>8.The ownership of the prepaid card in your possession belongs to ourcompany. When our company requests its return in accordance with the relevantterms and conditions, you are obligated to return it.</p>
<p>9.The Company may provide, modify, suspend, revoke, or cancel anyservice, account card, or your use of the account card at any time withoutprior notice. The Company may also add, modify, restrict, suspend, revoke, orcancel all or any rights, services, facilities, and privileges related to youraccount card. Upon cancellation of the account card, the full amount of anytransaction made using the account card or authentication factor shall beimmediately payable.</p>
<p><strong>Your responsibility</strong></p>
<p>10.Even in the following circumstances, you shall remain liable:<br>
i）You did not sign the sales slip (including where the transaction may be conducted by telephone, mail, electronic means, or direct payment arrangement without requiring a sales slip or your signature); or the signature on the sales slip differs from the signature on your prepaid card; or<br>
ii）The transaction was not conducted with your consent.</p>
<p>11.The account cardholder shall be responsible for the following matters:<br>
i All transactions made using the Prepaid Card and authentication factors (including all related fees and charges), including those made with the cardholder's own Prepaid Card and authentication factors and those made with the Prepaid Card and authentication factors of any supplementary cardholder; and<br>
ii）The primary cardholder and any supplementary cardholder have failed to comply with these terms and conditions.<br>
a)	The supplementary cardholder shall be responsible for the use of his/her own prepaid card and authentication factors, but shall not be liable for the use of their prepaid card or authentication factors by the primary cardholder or any other supplementary cardholder.<br>
b)	Whether or not you are aware of it, you should not use your prepaid card for any transaction that may violate the laws of any jurisdiction.<br>
c)	Even if your account card has been terminated, you remain responsible for this.</p>
<p>12. You agree that when the prepaid card or authentication factor isused to conduct, process, or execute any transaction, it shall be deemed thatyou have authorized and are aware of such use, regardless of whether you haveactually authorized and/or are aware of such use of the prepaid card orauthentication factor. The Company shall debit your account for any amountincurred through transactions or processing using the prepaid card orauthentication factor. The Company's records of all transactions conductedusing the prepaid card or authentication factor shall be deemed accurate andfinal (except for obvious errors), and you agree to be bound by such records.</p>
<p><strong>Safety and Security Measures</strong></p>
<p>13.You should take appropriate security precautions, including the following:<br>
a)	Sign your account card immediately upon receipt.<br>
b)	Safeguard your prepaid card and mobile device and keep them in your possession at all times. Treat your prepaid card with the same care you would cash.<br>
c)	After using the ATM, remember to retrieve your prepaid card.<br>
d)	Ensure that merchants promptly return the prepaid card to you after completing the prepaid card transaction.<br>
e)	Keep your authentication factors and device passwords strictly confidential;<br>
f)	When using authentication factors and device passwords, please ensure that neither the authentication factors nor the device passwords are visible to others.<br>
g)	Regularly change your personal password and device passcode;<br>
h)	If your personal password or device passcode has been or may have been viewed by others, you should change it immediately.<br>
i)	Never write down your authentication factors or device passcode, nor record them on your prepaid card, store them with your prepaid card, or handle them in any other way that could allow others to use your prepaid card, authentication factors, or mobile device. You should obscure any records of your authentication factors or device passcode.<br>
j)	Never use easily guessable numbers as your personal password or device passcode (such as ID numbers, birth dates, phone numbers, or other readily accessible personal information) and use alphanumeric codes where applicable;<br>
k)	Do not use the same private password or device password for other services or purposes, such as connecting to the internet or logging into other websites.<br>
l)	Do not transfer your prepaid card, authentication factors, device passcode, or mobile device, nor permit any other person to use your prepaid card, authentication factors, device passcode, or mobile device.<br>
m)	Each time you make a purchase, remember to fill in the total amount on the receipt and include the currency code before the amount. Do not leave any spaces for others to fill in.<br>
n)	Ensure that only one receipt is printed per transaction;<br>
o)	Retain the cardholder stub of each Prepaid Card transaction slip and reconcile it with the Prepaid Card statement or records; and<br>
p)	Please ensure that the contact information you have registered with our company for receiving important notifications (such as SMS and email notifications for online payments) is up to date so that such notifications can be delivered to you in a timely manner.</p>
<p><strong>Report Loss if your account card, authentication factor, or mobile device is lost, stolen, or misused.</strong></p>
<p>14.If your prepaid card, authentication factor, or mobile device is lost, stolen, compromised, or used without authorization, you must promptly report this to us and provide written confirmation as soon as reasonably practicable. You remain liable for all transactions made using your prepaid card or authentication factor prior to our receipt of your report.</p>
<p>15. Without limiting or impairing the effect of Section 17(a), if your account statement shows any transaction not authorized by you, you shall promptly notify the Company. You must submit a chargeback request to the Company within 45 days after the transaction. If you fail to notify us within this 45-day period, the transaction shall be deemed correct, final, and binding upon you, and you shall be deemed to have waived any right to raise objections or seek remedies against us in relation to such transaction.</p>
<p><strong>Your Liability for Unauthorized Transactions</strong></p>
<p>16.	If you report the loss, theft, compromise, or unauthorized use of your prepaid card, authentication factor, or mobile device under Section 14(b), your liability for unauthorized transactions will be determined on a case-by-case basis.</p>
<p>17. If you knowingly (whether voluntarily or not) permit any otherperson to use your prepaid card, authentication factor, or mobile device; or ifyou commit fraud or act with gross negligence in the use or custody of yourdebit card, authentication factor, or mobile device. Failure to implement anysecurity measures recommended by us from time to time regarding the use orcustody of your debit card, authentication factor, or mobile device may bedeemed gross negligence on your part, and you may be held liable for thetransaction amount.</p>
<p><strong>Compensation</strong></p>
<p>18.	To the fullest extent permitted by law, you agree to indemnify and hold harmless the Company (and all its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the "Indemnified Parties") from and against any and all claims, demands, actions, proceedings, liabilities, losses, damages, penalties, penalties, fines, expenses, and costs (including reasonable legal fees as determined by a court of competent jurisdiction) incurred by the Company (and all of its affiliated entities, directors, officers, subsidiaries, employees, service providers, members, representatives, and agents, collectively referred to as the "Indemnified Parties") in connection with:<br>
a)	Your conduct and your use of our services;<br>
b)	You violate these Terms or our Anti-Money Laundering ("AML") policy;<br>
c)	You violate any law, regulation, or rule;<br>
d)	You violate or infringe upon the Company's copyrights, intellectual property rights, trade secrets, patents, trademarks, service marks, or any other legally protected proprietary rights;<br>
e)	You have failed to properly safeguard or maintain the confidentiality of your account card credentials or any other identity verification data as required under Article 16;<br>
f)	Any damages caused by you to our services, any user, or any other individual or entity; or<br>
g)	Any rights exercised by the Company pursuant to these terms.</p>
<p>19.	This indemnification includes, but is not limited to, liabilities related to intellectual property, defamation, and invasion of privacy.</p>
<p><strong>Disclaimer and Exceptions</strong></p>
<p>20.	The Company shall not be liable to you or any other person for any of the following (or any one thereof):<br>
a)	Any failure or delay by the Company in providing any services, equipment, or other facilities to you that may be attributable to circumstances beyond the Company's reasonable control;<br>
b)	The availability or performance of any point-of-sale terminal or other device provided or operated by a merchant or any other person for the use of a prepaid card or any of its features (including contactless payment functionality); and<br>
c)	Consequential or indirect losses arising from or in connection with the use of your prepaid card or authentication factor.</p>
<p>21The Company shall not be liable for any merchant's refusal to accept your prepaid card or authentication factor. The Company shall also not be liable for any goods or services provided to you by any merchant. Your obligations to the Company under these Terms and Conditions shall not be affected, waived, or reduced by any claim you may have against a merchant. You shall be solely responsible for resolving any disputes with merchants. In particular, you and the merchant must agree to establish, modify, or terminate any automatic transfer or direct debit arrangement for charging payments to your account. In the event of any dispute between you and the merchant, the Company reserves the right not to execute any request to establish, modify, or terminate such arrangements.</p>
<p>22.Even if any merchant fails to provide goods or services or fails to fulfill its obligations, or if any goods or services provided by any merchant are defective, or if any merchant fails to provide you with any goods, services, offers, discounts, or programs, the Company reserves the right to deduct from your account all transactions made using your prepaid card or authentication factors. You must seek redress directly from the relevant merchant regarding such goods, services, offers, discounts, or programs.</p>
<p>23.	The Company reserves the right to convert the refund amount into another currency at a time and exchange rate deemed appropriate by the Company. You shall bear all related exchange rate risks, losses, commissions, and other charges and fees.</p>
<p>24.	Under no circumstances shall the Company, its affiliates, service providers, or any of their respective officers, directors, agents, partners, employees, or representatives be liable for:<br>
a)	Any loss of profits, goodwill or reputation, loss of data, impairment of value or business opportunities, loss, damage, deterioration, or disclosure of any data or other intangible property, or any special, incidental, indirect, intangible, or consequential damages arising out of or in connection with the use of the Company's website or services or this Agreement, whether based on contract, tort, negligence, strict liability, or otherwise, even if the Company has been advised of, knew of, or ought to have known of the possibility of such damages, and even if any agreed-upon or other remedy fails of its essential purpose. The Company shall not be liable for such damages unless a final judicial determination establishes that such damages resulted from the Company's gross negligence, fraud, or intentional misconduct, or intentional violation of law.</p>
<p><strong>Governing Law and Dispute Resolution</strong></p>
<p>25.	These terms shall be governed by and construed in accordance with the laws of Hong Kong, without regard to its conflict of laws principles.</p>
<p>26.	If you are a consumer and have any complaints, we encourage you to first contact our customer service team via our website www.hongkongtrust.com.hk and email info@hktcm.com.</p>
<p>27.	If the complaint is not resolved to your satisfaction, you may refer the matter to the Hong Kong Mediation and Arbitration Centre for mediation, followed by arbitration at the Hong Kong International Arbitration Centre in accordance with its then-current Arbitration Rules ("HKIAC Rules"). Should mediation fail, such rules shall be deemed incorporated by reference into these Terms.</p>
<p>28.	The language of the arbitration shall be English. The place of arbitration shall be Hong Kong. Unless otherwise determined by the arbitral tribunal, each party shall bear its own arbitration costs.</p>
</div>
<div class="terms-footer">
<div class="terms-checkbox">
<input type="checkbox" id="termsAgree" v-model="termsAgreed" :disabled="!canAgree">
<label for="termsAgree" class="terms-checkbox-label">
I confirm that I have read and agree to the 'HKTCM Global Visa prepaid card Terms and Conditions.'<br>
<span>Please check this box to confirm you have read and agree to the terms before proceeding with the application.</span>
</label>
</div>
<div class="terms-actions">
<el-button @click="closeTermsDialog" class="terms-cancel">Cancel</el-button>
<el-button @click="acceptTerms" :disabled="!termsAgreed" class="terms-accept">Accept</el-button>
</div>
</div>
</el-dialog>

<!-- 申请表单弹窗 -->
<el-dialog 
  :visible.sync="applicationFormVisible" 
  :title="applicationType === 'primary' ? 'Primary Card Application Form' : 'Supplementary Card Application Form'" 
  class="application-form-dialog" 
  width="1400px" 
  append-to-body
>
  <div class="step-nav">
    <div class="step">
      <div class="step-number" :class="{ 'active': currentStep === 1 }">1</div>
      <div class="step-label" :class="{ 'active': currentStep === 1 }">
        {{ applicationType === 'primary' ? 'Applicant Info' : 'Holder Info' }}
      </div>
    </div>
    <div class="step-connector" :class="{ 'active': currentStep >= 2 }"></div>
    <div class="step">
      <div class="step-number" :class="{ 'active': currentStep === 2 }">2</div>
      <div class="step-label" :class="{ 'active': currentStep === 2 }">Card Configuration</div>
    </div>
  </div>

  <!-- Step 1: 申请人/持有人信息 -->
  <div v-if="currentStep === 1" class="form-section">
    <h3 class="section-title">
      {{ applicationType === 'primary' ? 'Applicant and Trust Account Information' : 'Supplementary Cardholder Information' }}
    </h3>
    
    <!-- 如果是主卡，显示只读的信托账号和申请人姓名 -->
    <div v-if="applicationType === 'primary'" class="preview-title" style="margin-bottom: 20px;">
      Applicant: {{ formData.Name }}
    </div>
    
    <!-- 如果是附属卡，提示当前正在为谁申请 -->
    <div v-if="applicationType === 'supplementary'" class="preview-title" style="margin-bottom: 20px; color: var(--primary-color);">
      Applying for Supplementary Card under Trust Account: {{ formData.username }}
    </div>

    <!-- 第一组：基本身份信息 -->
    <div class="form-group-title">Basic Identity Information</div>
    <!-- <div class="part-a-grid">
      
      <div class="form-group" v-if="applicationType === 'primary'">
        <label class="form-label">Trust account number</label>
        <el-input v-model="formData.username" readonly class="form-input readonly-input"></el-input>
      </div>
  
      <div class="form-group" v-if="applicationType === 'primary'">
        <label class="form-label">Application No.</label>
        <el-input v-model="formData.busiWaterNo" readonly class="form-input readonly-input" placeholder="Auto-generated"></el-input>
      </div>

      <div class="form-group">
        <label class="form-label">Name (Legal)<span style="color: #EF4444;">*</span></label>
    
        <el-input 
          v-model="formData.Name" 
          :readonly="applicationType === 'primary'" 
          :placeholder="applicationType === 'supplementary' ? 'Please enter name' : ''"
          class="form-input" 
          :class="{ 'readonly-input': applicationType === 'primary', 'required-input': applicationType === 'supplementary' }"
        ></el-input>
      </div> -->
      <div class="part-a-grid">
  <!-- 信托账号：移除 readonly，改为可手动填写 -->
  <div class="form-group" v-if="applicationType === 'primary'">
    <label class="form-label">Trust account number</label>
    <el-input 
      v-model="formData.username" 
      class="form-input" 
      placeholder="Please enter trust account number"
    ></el-input>
  </div>
  
  <!-- 流水号：移除 readonly，改为可手动填写 -->
  <div class="form-group" v-if="applicationType === 'primary'">
    <label class="form-label">Application No.</label>
    <el-input 
      v-model="formData.busiWaterNo" 
      class="form-input" 
      placeholder="Please enter application number"
    ></el-input>
  </div>

  <!-- 法定名称：移除条件判断的 readonly，统一改为可手动填写，并设为必填样式 -->
  <div class="form-group">
    <label class="form-label">Name (Legal)<span style="color: #EF4444;">*</span></label>
    <el-input 
      v-model="formData.Name" 
      placeholder="Please enter name"
      class="form-input required-input"
    ></el-input>
  </div>
      
      <div class="form-group">
        <label class="form-label">English Name<span style="color: #EF4444;">*</span></label>
        <el-input 
          v-model="formData.englishName" 
          @input="handleEnglishNameInput" 
          placeholder="Please enter English name (A-Z, spaces only)" 
          class="form-input required-input" 
          maxlength="50"
        ></el-input>
      </div>
      
      <div class="form-group">
        <label class="form-label">Gender<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.gender" placeholder="Please select" class="form-input required-input">
          <el-option label="Male" value="male"></el-option>
          <el-option label="Female" value="female"></el-option>
        </el-select>
      </div>
    </div>
    
    <div class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group">
        <label class="form-label">Nationality<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.nationality" filterable placeholder="Please select" class="form-input required-input">
          <el-option v-for="country in countryList" :key="country.code" :label="country.name" :value="country.name" />
        </el-select>
      </div>
      <div class="form-group">
        <label class="form-label">Date of Birth<span style="color: #EF4444;">*</span></label>
        <el-date-picker v-model="formData.dateOfBirth" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
      </div>
      <div class="form-group">
        <label class="form-label">National Identity Card Number/Passport <span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.idNumber" placeholder="Please enter your identification number" class="form-input required-input"></el-input>
      </div>
      <div class="form-group">
        <label class="form-label">ID Type<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.idType" placeholder="Select ID Type" class="form-input required-input" @change="handleIdTypeChange">
          <el-option label="Mainland Resident Permit" value="MainlandID"></el-option>
          <el-option label="Hong Kong Identity Card" value="HKID"></el-option>
          <el-option label="Passport" value="Passport"></el-option>
          <el-option label="Other" value="Other"></el-option>
        </el-select>
      </div>
    </div>

    <!-- 第二组：证件详细信息 -->
    <div class="form-group-title" style="margin-top: 25px;">ID Document Details</div>
    <div class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group">
        <label class="form-label">ID Issue Date<span style="color: #EF4444;">*</span></label>
        <el-date-picker v-model="formData.idIssueDate" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
      </div>
      <div class="form-group" v-if="formData.idType !== 'HKID' && formData.idType !== 'Other'">
        <label class="form-label">ID Expiry Date <span style="color: #EF4444;">*</span></label>
        <el-date-picker v-model="formData.idExpiryDate" type="date" placeholder="Select date" class="form-input required-input" style="width:100%" value-format="yyyy-MM-dd" placement="bottom-start"></el-date-picker>
      </div>
      <div class="form-group" style="grid-column: span 2;">
        <label class="form-label">ID Card Address<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.idAddress" type="textarea" :rows="2" placeholder="Address as shown on ID document" class="form-input required-input"></el-input>
      </div>
    </div>

    <!-- 第三组：证件上传 -->
    <div class="form-group-title" style="margin-top: 25px;">ID Document Upload<span style="color: #EF4444;">*</span></div>
    <div class="upload-section" style="margin-top: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px;">
      <div class="upload-notice" style="margin-bottom: 15px; color: #666; font-size: 13px;">
        <strong>📋 Upload Requirements:</strong>
        <ul style="margin: 8px 0 0 20px; padding: 0;">
          <li>Mainland ID: Front (Portrait) + Back (Emblem) pages required</li>
          <li>HK ID: Information page required</li>
          <li>Passport/Other: Information page required</li>
          <li>File format: JPG, PNG, or PDF | Max size: 5MB per file</li>
        </ul>
      </div>
      <div class="part-a-grid">
        <div class="form-group" v-if="formData.idType === 'MainlandID'">
          <label class="form-label">ID Front (Portrait) <span style="color: #EF4444;">*</span></label>
          <el-upload action="#" :file-list="formData.idDocFrontFileList" :on-change="(file) => handleIdUpload(file, 'idDocFrontUrl', 'idDocFrontFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
            <el-button size="small" type="primary">Upload Front</el-button>
          </el-upload>
          <div v-if="formData.idDocFrontFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocFrontFileList[0].name }}</div>
        </div>
        <div class="form-group" v-if="formData.idType === 'MainlandID'">
          <label class="form-label">ID Back (Emblem) <span style="color: #EF4444;">*</span></label>
          <el-upload action="#" :file-list="formData.idDocBackFileList" :on-change="(file) => handleIdUpload(file, 'idDocBackUrl', 'idDocBackFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
            <el-button size="small" type="primary">Upload Back</el-button>
          </el-upload>
          <div v-if="formData.idDocBackFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocBackFileList[0].name }}</div>
        </div>
        <div class="form-group" v-if="formData.idType === 'HKID'">
          <label class="form-label">ID Information Page <span style="color: #EF4444;">*</span></label>
          <el-upload action="#" :file-list="formData.idDocInfoFileList" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl', 'idDocInfoFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
            <el-button size="small" type="primary">Upload ID Page</el-button>
          </el-upload>
          <div v-if="formData.idDocInfoFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocInfoFileList[0].name }}</div>
        </div>
        <div class="form-group" v-if="formData.idType === 'Passport' || formData.idType === 'Other'">
          <label class="form-label">Passport/ID Information Page <span style="color: #EF4444;">*</span></label>
          <el-upload action="#" :file-list="formData.idDocInfoFileList" :on-change="(file) => handleIdUpload(file, 'idDocInfoUrl', 'idDocInfoFileList')" :auto-upload="false" :limit="1" accept=".jpg,.png,.pdf" class="upload-component">
            <el-button size="small" type="primary">Upload Page</el-button>
          </el-upload>
          <div v-if="formData.idDocInfoFileList.length > 0" class="file-status" style="font-size: 12px; color: #10b981; margin-top: 5px;">✓ {{ formData.idDocInfoFileList[0].name }}</div>
        </div>
      </div>
    </div>

    <!-- 第四组：联系信息 -->
    <div class="form-group-title" style="margin-top: 25px;">Contact Information</div>
    <div class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group">
        <label class="form-label">Telephone<span style="color: #EF4444;">*</span></label>
        <div style="display:flex; gap:8px;">
          <el-select v-model="formData.phoneCode" filterable placeholder="Code" style="width: 240px;" class="form-input">
            <el-option label="+852 HK" value="+852" />
            <el-option label="+86 CN" value="+86" />
            <el-option label="+853 MO" value="+853" />
            <el-option label="+886 TW" value="+886" />
            <el-option label="+65 SG" value="+65" />
            <el-option label="+60 MY" value="+60" />
            <el-option label="+971 AE" value="+971" />
            <el-option label="+82 KR" value="+82" />
            <el-option label="+81 JP" value="+81" />
            <el-option label="+66 TH" value="+66" />
            <el-option label="+1 US/CA" value="+1" />
            <el-option label="+44 UK" value="+44" />
            <el-option label="+61 AU" value="+61" />
          </el-select>
          <el-input v-model="formData.phone" @input="handlePhoneInput(1, $event.target.value)" placeholder="Phone number" class="form-input required-input"></el-input>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Email address<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.email" placeholder="Please enter your email address" type="email" class="form-input required-input"></el-input>
      </div>
      <div class="form-group" style="grid-column: span 2;">
        <label class="form-label">Postal Address (Mailing)<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.address" type="textarea" :rows="2" placeholder="Please enter your full postal address" class="form-input required-input"></el-input>
      </div>
    </div>

    <!-- 第五组：职业与合规信息 -->
    <div class="form-group-title" style="margin-top: 25px;">Professional & Compliance Information<span style="color: #EF4444;">*</span></div>
    <div class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group">
        <label class="form-label">Occupation Type<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.occupation" placeholder="Select Occupation" class="form-input required-input">
          <el-option v-for="opt in industryOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
        </el-select>
      </div>
      <div class="form-group">
        <label class="form-label">Position<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.jobTitle" placeholder="Select Position" class="form-input required-input">
          <el-option v-for="opt in positionOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
        </el-select>
      </div>
      <div class="form-group">
        <label class="form-label">Years of Service<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.yearsOfService" placeholder="e.g. 5 years" class="form-input required-input"></el-input>
      </div>
      <div class="form-group">
        <label class="form-label">Yearly Income<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.yearlyIncome" placeholder="e.g. 500000" class="form-input required-input"></el-input>
      </div>
    </div>
    <div class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group" style="grid-column: span 2;">
        <label class="form-label">Company Name<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.companyName" placeholder="Please enter company name" class="form-input required-input"></el-input>
      </div>
      <div class="form-group" style="grid-column: span 2;">
        <label class="form-label">Office Address<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.officeAddress" type="textarea" :rows="2" placeholder="Please enter office address" class="form-input required-input"></el-input>
      </div>
    </div>
    <div class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group">
        <label class="form-label">Office Tel. No.<span style="color: #EF4444;">*</span></label>
        <div style="display:flex; gap:8px;">
          <el-select v-model="formData.officeTelCode" filterable placeholder="Code" style="width: 240px;" class="form-input">
            <el-option label="+852 HK" value="+852" />
            <el-option label="+86 CN" value="+86" />
            <el-option label="+853 MO" value="+853" />
            <el-option label="+886 TW" value="+886" />
            <el-option label="+65 SG" value="+65" />
            <el-option label="+60 MY" value="+60" />
            <el-option label="+971 AE" value="+971" />
            <el-option label="+82 KR" value="+82" />
            <el-option label="+81 JP" value="+81" />
            <el-option label="+66 TH" value="+66" />
            <el-option label="+1 US/CA" value="+1" />
            <el-option label="+44 UK" value="+44" />
            <el-option label="+61 AU" value="+61" />
          </el-select>
          <el-input v-model="formData.officeTel" placeholder="Office number" class="form-input required-input"></el-input>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">Purpose of Account<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.accountPurpose" placeholder="Select Purpose" class="form-input required-input" @change="handlePurposeChange">
          <el-option v-for="opt in purposeOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
        </el-select>
      </div>
      <div class="form-group">
        <label class="form-label">Source of Wealth<span style="color: #EF4444;">*</span></label>
        <el-select v-model="formData.sourceOfWealth" placeholder="Select Source" class="form-input required-input" @change="handleWealthChange">
          <el-option v-for="opt in wealthOptions" :key="opt.value" :label="opt.label" :value="opt.value"></el-option>
        </el-select>
      </div>
      <div class="form-group" v-if="formData.sourceOfWealth === '07'">
        <label class="form-label">Source of Wealth (Please note)<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.sourceOfWealthOther" placeholder="Please specify" class="form-input required-input"></el-input>
      </div>
    </div>

    <!-- ✅ 新增：支付密码设置 (仅主卡显示) -->
    <div v-if="applicationType === 'primary'" class="form-group-title" style="margin-top: 25px;">Account Security</div>
    <div v-if="applicationType === 'primary'" class="part-a-grid" style="margin-top: 20px;">
      <div class="form-group">
        <label class="form-label">Payment Password<span style="color: #EF4444;">*</span></label>
        <el-input v-model="formData.paymentPassword" type="password" placeholder="Please enter 6-digit payment password" class="form-input required-input" maxlength="6" show-password></el-input><span>Please enter six digits (numbers only)</span>
      </div>
    </div>
  </div>

  <!-- Step 2: 卡片配置 -->
  <div v-if="currentStep === 2" class="form-section">
    <h3 class="section-title">Prepaid Card Distribution Information</h3>
    
    <!-- 主卡逻辑：显示主卡配置 -->
    <div v-if="applicationType === 'primary'">
      <div style="font-size: 14px; margin-bottom: 20px; color: var(--text-secondary);">
        Prepaid Card will be issued to (name must not exceed 20 characters, including spaces)
      </div>
      <div style="margin-bottom: 25px;">
        <div style="font-weight: bold; margin-bottom: 8px;">Name on the card</div>
        <div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px; flex-wrap: wrap;">
          <span style="min-width: 100px;">Primary cardholder:</span>
          <div style="flex: 1; position: relative;">
            <el-input v-model="formData.cardName1" @input="handleCardName1Input" placeholder="Please enter English name only" class="form-input"></el-input>
            <span class="char-counter" :class="getCharCountClass(formData.cardName1 ? formData.cardName1.length : 0)" style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">{{ formData.cardName1 ? formData.cardName1.length : 0 }}/20</span>
          </div>
        </div>
        <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 20px;">
          <span>Application Category:</span>
          <template v-for="option in availableCardTypes">
            <label :key="option.value" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
              <input type="radio" v-model="formData.cardType1" :value="option.value" :name="'cardType1'"> {{ option.label }}
            </label>
          </template>
        </div>
        <div v-if="formData.cardType1" class="card-preview">
          <img :src="getCardImage(formData.cardType1, formData.showLogoOnCard1)" alt="Prepaid Card Preview"/>
          <div v-if="formData.showNameOnCard1" class="name-overlay" :style="{ color: formData.cardType1 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName1 || 'Contact Information' }}</div>
        </div>
        <div v-if="formData.cardType1" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
          <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
            <input type="checkbox" v-model="formData.showNameOnCard1"> Display Cardholder's Name
          </label>
          <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
            <input type="checkbox" v-model="formData.showLogoOnCard1"> Display Company Logo
          </label>
        </div>
        
        <!-- 主卡签名 -->
        <div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
          <div class="form-group-title" style="margin-top: 0;">Electronic Signature - Primary Cardholder</div>
          <div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
             <p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
             <strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
             <ul style="padding-left: 20px; margin: 0;">
                <li style="margin-bottom: 8px;">Applicant must apply HKTCM Global VISA Prepaid Card in Hong Kong and aged 18 or above. HKTCM 環球VISA 預付卡申請人須為年滿 18 歲及在香港申請。</li>
                <li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Hong Kong Trust Capital Management Limited (“HKTCM”). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
                <li style="margin-bottom: 8px;">I agree and authorize Hong Kong Trust Capital Management Limited to review the accuracy and authenticity of all information on this Application Form, and Hong Kong Trust Capital Management Limited shall have full power to accept the application.<br>本人同意及授權香港信託資產管理有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意香港信託資產管理有限公司持最終審批權；</li>
                <li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Hong Kong Trust Capital Management Limited.<br>本人已閱讀、明白及同意香港信託資產管理有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
                <li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a HKTCM Global VISA Prepaid Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立HKTCM 環球VISA 預付卡。</li>
             </ul>
          </div>
          <div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
            <div style="flex: 1; min-width: 300px;">
              <SignaturePad ref="sigPad1" v-model="formData.signatureData1" title="Please sign above" :width="500" :height="200" @input="handleSignatureUpdate(1, $event)" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 附属卡逻辑：显示附属卡配置 -->
    <div v-if="applicationType === 'supplementary'">
      <div style="font-size: 14px; margin-bottom: 20px; color: var(--text-secondary);">
        Supplementary Card Configuration
      </div>
      
      <!-- 附属卡持卡人姓名 (从 Step 1 自动带入或手动确认) -->
      <div style="margin-bottom: 25px;">
        <div style="font-weight: bold; margin-bottom: 8px;">Name on the card</div>
        <div style="display: flex; align-items: center; margin-bottom: 16px; gap: 12px; flex-wrap: wrap;">
          <span style="min-width: 100px;">Cardholder:</span>
          <div style="flex: 1; position: relative;">
            <!-- 这里使用 cardName2 作为当前申请的附属卡姓名，方便后续提交 -->
            <el-input v-model="formData.cardName2" @input="handleCardName2Input" placeholder="Please enter English name only" class="form-input"></el-input>
            <span class="char-counter" :class="getCharCountClass(formData.cardName2 ? formData.cardName2.length : 0)" style="position: absolute; right: 10px; bottom: 8px; font-size: 12px;">{{ formData.cardName2 ? formData.cardName2.length : 0 }}/20</span>
          </div>
        </div>
        
        <!-- 卡种选择 -->
        <div style="display: flex; align-items: center; gap: 16px; margin-left: 100px; margin-bottom: 20px;">
          <span>Application Category:</span>
          <template v-for="option in availableCardTypes">
            <label :key="`supp-${option.value}`" style="display: flex; align-items: center; gap: 4px; cursor: pointer;" v-if="option.visible">
              <input type="radio" v-model="formData.cardType2" :value="option.value" :name="'cardTypeSupp'"> {{ option.label }}
            </label>
          </template>
        </div>
        
        <!-- 预览 -->
        <div v-if="formData.cardType2" class="card-preview">
          <img :src="getCardImage(formData.cardType2, formData.showLogoOnCard2)" alt="Prepaid Card Preview"/>
          <div v-if="formData.showNameOnCard2" class="name-overlay" :style="{ color: formData.cardType2 === 'black' ? '#d6c6a4' : '#ffffff' }">{{ formData.cardName2 || 'Contact Information' }}</div>
        </div>
        
        <!-- 选项 -->
        <div v-if="formData.cardType2" style="margin-top: 10px; display: flex; gap: 20px; font-size: 13px; color: var(--text-secondary);">
          <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
            <input type="checkbox" v-model="formData.showNameOnCard2"> Display Cardholder's Name
          </label>
          <label style="display: flex; align-items: center; gap: 6px; cursor: pointer;">
            <input type="checkbox" v-model="formData.showLogoOnCard2"> Display Company Logo
          </label>
        </div>
        
        <!-- 附属卡额度设置 -->
        <div class="form-group-title" style="margin-top: 20px;">💳 Credit Limit Setting</div>
        <div class="part-a-grid" style="margin-top: 15px;">
          <div class="form-group">
            <label class="form-label">Credit Limit (HKD) <span style="color: #EF4444;">*</span></label>
            <el-input v-model="formData.creditLimit2" placeholder="e.g. 50000" class="form-input required-input"></el-input>
          </div>
        </div>

        <!-- ✅ 新增：附属卡支付密码设置 -->
        <div class="form-group-title" style="margin-top: 25px;">Account Security (Supplementary)</div>
        <div class="part-a-grid" style="margin-top: 20px;">
          <div class="form-group">
            <label class="form-label">Payment Password<span style="color: #EF4444;">*</span></label>
            <el-input 
              v-model="formData.paymentPassword2" 
              type="password" 
              placeholder="Please enter 6-digit payment password" 
              class="form-input required-input" 
              maxlength="6" 
              show-password
            ></el-input>
            <span style="font-size: 12px; color: #666;">Please enter six digits (numbers only)</span>
          </div>
        </div>

        <!-- 附属卡签名 -->
        <div class="signature-section" style="margin-top: 30px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e2e8f0;">
          <div class="form-group-title" style="margin-top: 0;">Electronic Signature - Supplementary Cardholder</div>
          <div class="declaration-text" style="margin: 15px 0; padding: 15px; background: #fff; border: 1px solid #ddd; border-radius: 4px; font-size: 13px; line-height: 1.6; max-height: 200px; overflow-y: auto;">
             <p style="margin-bottom: 10px;"><strong>I (The Applicant) hereby declare that after signing in the signature column herein below by myself (the Applicant), indicated that I have already fully read, understood, agreed, confirmed and accepted:</strong><br>
             <strong>本人 (申請人) 謹此聲明，當本人於下列簽署欄內簽署後，即表示本人已細閱、同意、明白、確認及遵守以下各項聲明：</strong></p>
             <ul style="padding-left: 20px; margin: 0;">
                <li style="margin-bottom: 8px;">Applicant must apply HKTCM Global VISA Prepaid Card in Hong Kong and aged 18 or above. HKTCM 環球VISA 預付卡申請人須為年滿 18 歲及在香港申請。</li>
                <li style="margin-bottom: 8px;">The information provided in this Application Form is in all respects complete, true and accurate, and I should provide supporting documents and other information as required by Hong Kong Trust Capital Management Limited (“HKTCM”). I shall bear the legal responsibility for the above information;<br>本人確認本申請表格上提供的所有資料均為完整、真實及準確，及同意隨時提供相關證明、文件及其他補充資料；如有不實之處，本人願意承擔由此導致的法律責任；</li>
                <li style="margin-bottom: 8px;">I agree and authorize Hong Kong Trust Capital Management Limited to review the accuracy and authenticity of all information on this Application Form, and Hong Kong Trust Capital Management Limited shall have full power to accept the application.<br>本人同意及授權香港信託資產管理有限公司查詢、檢查及審核填寫在此申請表上的所有資料及申請事項，並同意香港信託資產管理有限公司持最終審批權；</li>
                <li style="margin-bottom: 8px;">I have read, understood and agreed to be bound by all clauses of《Terms and Conditions》, charges, limits and Privacy Policy as issued by Hong Kong Trust Capital Management Limited.<br>本人已閱讀、明白及同意香港信託資產管理有限公司發佈並不時修改的《條款及細則》、限額、收費及私隱政策，並同意接受其約束。</li>
                <li>I agree and understand that my personal data will be collected by my agent or Authorized Person of The Company for the purpose of opening a HKTCM Global VISA Prepaid Card.<br>本人同意及明白代理人或代辦公司會收集本人的個人資料用作開立HKTCM 環球VISA 預付卡。</li>
             </ul>
          </div>
          <div style="display: flex; align-items: flex-start; gap: 20px; flex-wrap: wrap;">
            <div style="flex: 1; min-width: 300px;">
              <!-- 使用 sigPad2 存储当前附属卡的签名 -->
              <SignaturePad ref="sigPad2" v-model="formData.signatureData2" title="Please sign above" :width="500" :height="200" @input="handleSignatureUpdate(2, $event)" />
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="form-footer" slot="footer">
    <el-button v-if="currentStep > 1" @click="prevStep" class="form-btn btn-prev">Previous step</el-button>
    <el-button v-if="currentStep < 2" @click="nextStep" class="form-btn btn-next">Next step</el-button>
    <el-button v-if="currentStep === 2" type="primary" @click="submitApplication" class="form-btn btn-submit">Submit an application</el-button>
  </div>
</el-dialog>

<!-- 预览确认弹窗 -->
<el-dialog :visible.sync="previewVisible" title="Application Information Preview" width="1000px" :append-to-body="true">
<div v-if="previewData" class="preview-content">
<h3 style="text-align: center; margin-bottom: 20px;">
  {{ previewData.applicationType === 'primary' ? 'Primary Card Application Preview' : 'Supplementary Card Application Preview' }}
</h3>

<!-- 通用申请人信息预览 -->
<h4 class="section-title">Applicant/Holder Information</h4>
<table class="preview-table">
<tr><th>Application No.:</th><td>{{ previewData.busiWaterNo || 'N/A' }}</td></tr>
<tr><th>Trust account number:</th><td>{{ previewData.username || 'N/A' }}</td></tr>
<tr><th>Name:</th><td>{{ previewData.Name }}</td></tr>
<tr><th>English Name:</th><td>{{ previewData.englishName || 'N/A' }}</td></tr>
<tr><th>Gender:</th><td>{{ previewData.gender }}</td></tr>
<tr><th>Nationality:</th><td>{{ previewData.nationality || 'N/A' }}</td></tr>
<tr><th>Date of Birth:</th><td>{{ previewData.dateOfBirth || 'N/A' }}</td></tr>
<tr><th>ID Type:</th><td>{{ previewData.idType || 'N/A' }}</td></tr>
<tr><th>ID Number:</th><td>{{ previewData.idNumber || 'N/A' }}</td></tr>
<tr><th>ID Issue Date:</th><td>{{ previewData.idIssueDate || 'N/A' }}</td></tr>
<tr><th>ID Expiry Date:</th><td>{{ previewData.idExpiryDate || 'N/A' }}</td></tr>
<tr><th>ID Address:</th><td>{{ previewData.idAddress || 'N/A' }}</td></tr>
<tr><th>ID Documents:</th><td>
<span v-if="previewData.idType === 'MainlandID'">Front: {{ previewData.idDocFrontFileList?.length > 0 ? '✓' : '✗' }} | Back: {{ previewData.idDocBackFileList?.length > 0 ? '✓' : '✗' }}</span>
<span v-else>Info Page: {{ previewData.idDocInfoFileList?.length > 0 ? '✓' : '✗' }}</span>
</td></tr>
<tr><th>Telephone:</th><td>{{ previewData.phoneCode }} {{ previewData.phone || 'N/A' }}</td></tr>
<tr><th>Email address:</th><td>{{ previewData.email || 'N/A' }}</td></tr>
<tr><th>Postal Address:</th><td>{{ previewData.address || 'N/A' }}</td></tr>
<tr><th>Occupation:</th><td>{{ previewData.occupation || 'N/A' }}</td></tr>
<tr><th>Position:</th><td>{{ previewData.jobTitle || 'N/A' }}</td></tr>
<tr><th>Years of Service:</th><td>{{ previewData.yearsOfService || 'N/A' }}</td></tr>
<tr><th>Yearly Income:</th><td>{{ previewData.yearlyIncome || 'N/A' }}</td></tr>
<tr><th>Company Name:</th><td>{{ previewData.companyName || 'N/A' }}</td></tr>
<tr><th>Office Address:</th><td>{{ previewData.officeAddress || 'N/A' }}</td></tr>
<tr><th>Office Tel:</th><td>{{ previewData.officeTelCode }} {{ previewData.officeTel || 'N/A' }}</td></tr>
<tr><th>Account Purpose:</th><td>{{ previewData.accountPurpose || 'N/A' }}</td></tr>
<tr><th>Source of Wealth:</th><td>{{ previewData.sourceOfWealth || 'N/A' }} {{ previewData.sourceOfWealthOther ? '(' + previewData.sourceOfWealthOther + ')' : '' }}</td></tr>
<tr><th>Signature Status:</th><td>{{ previewData.applicationType === 'primary' ? (previewData.isSigned1 ? '✓ Signed' : '✗ Not Signed') : (previewData.isSigned2 ? '✓ Signed' : '✗ Not Signed') }}</td></tr>
</table>

<!-- 卡片信息预览 -->
<h4 class="section-title">Card Information</h4>
<table class="preview-table">
<tr v-if="previewData.applicationType === 'primary'"><th>Cardholder Name:</th><td>{{ previewData.cardName1 || 'N/A' }}</td></tr>
<tr v-if="previewData.applicationType === 'supplementary'"><th>Cardholder Name:</th><td>{{ previewData.cardName2 || 'N/A' }}</td></tr>

<tr v-if="previewData.applicationType === 'primary'"><th>Card Type:</th><td>{{ previewData.cardType1 ? cardTypeLabels[previewData.cardType1] : 'N/A' }}</td></tr>
<tr v-if="previewData.applicationType === 'supplementary'"><th>Card Type:</th><td>{{ previewData.cardType2 ? cardTypeLabels[previewData.cardType2] : 'N/A' }}</td></tr>

<tr v-if="previewData.applicationType === 'primary'"><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard1) }}</td></tr>
<tr v-if="previewData.applicationType === 'supplementary'"><th>Display Name:</th><td>{{ boolToText(previewData.showNameOnCard2) }}</td></tr>

<tr v-if="previewData.applicationType === 'primary'"><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard1) }}</td></tr>
<tr v-if="previewData.applicationType === 'supplementary'"><th>Display Logo:</th><td>{{ boolToText(previewData.showLogoOnCard2) }}</td></tr>

<tr v-if="previewData.applicationType === 'supplementary'"><th>Credit Limit:</th><td>{{ previewData.creditLimit2 || 'N/A' }}</td></tr>

<!-- ✅ 新增：显示密码设置状态 -->
<tr v-if="previewData.applicationType === 'primary'"><th>Payment Password:</th><td>{{ previewData.paymentPassword ? '✓ Set' : '✗ Not Set' }}</td></tr>
<tr v-if="previewData.applicationType === 'supplementary'"><th>Payment Password:</th><td>{{ previewData.paymentPassword2 ? '✓ Set' : '✗ Not Set' }}</td></tr>
</table>
</div>
<div slot="footer" class="dialog-footer">
<el-button @click="previewVisible = false">Return to edit</el-button>
<el-button type="primary" @click="confirmAndSubmit">Confirm and submit</el-button>
</div>
</el-dialog>
</div>

<!-- 加载状态 -->
<div v-if="loading" class="loading-overlay">
<div class="loading-content">
<el-spinner :size="50"></el-spinner>
<p>Verifying token...</p>
</div>
</div>
</div>
</template>

<script>
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import {
Dialog, Form, FormItem, Input, Button, Select, Option, RadioGroup, Radio,
Upload, Steps, Step, Spinner, Loading, Message, DatePicker
} from 'element-ui';
// ✅ 导入 SignaturePad 组件
import SignaturePad from '@/views/SignaturePad.vue';

export default {
name: 'CreditCard',
components: {
[Dialog.name]: Dialog,
[Form.name]: Form,
[FormItem.name]: FormItem,
[Input.name]: Input,
[Button.name]: Button,
[Select.name]: Select,
[Option.name]: Option,
[RadioGroup.name]: RadioGroup,
[Radio.name]: Radio,
[Upload.name]: Upload,
[Steps.name]: Steps,
[Step.name]: Step,
[Spinner.name]: Spinner,
[DatePicker.name]: DatePicker,
// ✅ 注册 SignaturePad 组件
SignaturePad
},
data() {
return {
urlToken: '',
tokenValid: false,
loading: true,
adminCallbackUrl: '',
applicationType: 'primary', // 'primary' or 'supplementary'

// 🔹 Country List - 3-digit ISO codes
countryList: [
{ code: 'CHN', name: 'China' }, { code: 'HKG', name: 'Hong Kong, China' }, { code: 'MAC', name: 'Macau, China' },
{ code: 'TWN', name: 'Taiwan, China' }, { code: 'USA', name: 'United States' }, { code: 'GBR', name: 'United Kingdom' },
{ code: 'JPN', name: 'Japan' }, { code: 'SGP', name: 'Singapore' }, { code: 'KOR', name: 'South Korea' },
{ code: 'MYS', name: 'Malaysia' }, { code: 'THA', name: 'Thailand' }, { code: 'VNM', name: 'Vietnam' },
{ code: 'PHL', name: 'Philippines' }, { code: 'IDN', name: 'Indonesia' }, { code: 'IND', name: 'India' },
{ code: 'AUS', name: 'Australia' }, { code: 'NZL', name: 'New Zealand' }, { code: 'CAN', name: 'Canada' },
{ code: 'DEU', name: 'Germany' }, { code: 'FRA', name: 'France' }, { code: 'ITA', name: 'Italy' },
{ code: 'ESP', name: 'Spain' }, { code: 'NLD', name: 'Netherlands' }, { code: 'CHE', name: 'Switzerland' },
{ code: 'SWE', name: 'Sweden' }, { code: 'NOR', name: 'Norway' }, { code: 'DNK', name: 'Denmark' },
{ code: 'FIN', name: 'Finland' }, { code: 'RUS', name: 'Russia' }, { code: 'BRA', name: 'Brazil' },
{ code: 'MEX', name: 'Mexico' }, { code: 'ZAF', name: 'South Africa' }, { code: 'ARE', name: 'United Arab Emirates' },
{ code: 'SAU', name: 'Saudi Arabia' }, { code: 'TUR', name: 'Turkey' }, { code: 'OTHER', name: 'Other' }
],
// 🔹 Industry/Occupation Type - Numeric codes (3-digit)
industryOptions: [
{ label: '001 Government/Public Sector', value: '001' },
{ label: '002 Education', value: '002' },
{ label: '003 Utilities', value: '003' },
{ label: '004 Finance/Banking', value: '004' },
{ label: '005 Insurance', value: '005' },
{ label: '006 Securities & Commodities Trading', value: '006' },
{ label: '007 Legal', value: '007' },
{ label: '008 Medical/Healthcare', value: '008' },
{ label: '009 IT/Internet', value: '009' },
{ label: '010 Electronics', value: '010' },
{ label: '011 Communications/Telecom', value: '011' },
{ label: '012 Media/Film/Advertising/Arts & Culture', value: '012' },
{ label: '013 Retail/E-commerce', value: '013' },
{ label: '014 Catering/Entertainment & Recreation', value: '014' },
{ label: '015 Real Estate', value: '015' },
{ label: '016 Construction/Engineering', value: '016' },
{ label: '017 Logistics/Transport/Shipping/Aviation', value: '017' },
{ label: '018 Tourism/Hotels', value: '018' },
{ label: '019 Beauty/Wellness', value: '019' },
{ label: '020 Business Services', value: '020' },
{ label: '021 Virtual Currency/Crypto Dealers', value: '021' },
{ label: '022 Aircraft/Automobile/Yacht Dealers', value: '022' },
{ label: '023 Charities', value: '023' },
{ label: '024 Pawnbroking', value: '024' },
{ label: '025 Arms', value: '025' },
{ label: '026 Antiques/Auction', value: '026' },
{ label: '027 Manufacturing/Textiles/Agriculture, Forestry & Fisheries', value: '027' },
{ label: '028 Wholesale/Import-Export/Trading', value: '028' },
{ label: '029 Jewelry/Gemstone/Precious Metals Dealers', value: '029' },
{ label: '030 Money Exchange', value: '030' },
{ label: '031 Gaming/Casino', value: '031' },
{ label: '032 Online Gaming', value: '032' },
{ label: '033 Gas, Petroleum, Coal Products & Mining', value: '033' },
{ label: '035 Aerospace/Aerospace Technology', value: '035' },
{ label: '036 Chemicals & Chemical Products', value: '036' },
{ label: '037 Tobacco, Alcoholic Beverages', value: '037' },
{ label: '038 Construction Raw Materials', value: '038' },
{ label: '039 Chips & Semiconductors', value: '039' },
{ label: '999 Other', value: '999' }
],
// 🔹 Position/Job Title - Numeric codes (1-3)
positionOptions: [
{ label: '1 Rank-and-File Employee', value: '1' },
{ label: '2 Middle Management', value: '2' },
{ label: '3 Senior Management/Executive', value: '3' }
],
// 🔹 Account Purpose - 2-digit codes
purposeOptions: [
{ label: '01 Personal Shopping (Cardholder Self-use)', value: '01' },
{ label: '02 Salary/Bonus Disbursement & Withdrawal', value: '02' },
{ label: '03 Personal Purchasing Agent', value: '03' },
{ label: '05 Daily Small Expenses', value: '05' },
{ label: '06 Personal Financial Debt Payment', value: '06' },
{ label: '08 Payment for Friends', value: '08' },
{ label: '99 Other', value: '99' }
],
// 🔹 Source of Wealth - 2-digit codes
wealthOptions: [
{ label: '01 Salary', value: '01' },
{ label: '02 Investment Income', value: '02' },
{ label: '03 Business Income', value: '03' },
{ label: '04 Gambling/Betting Winnings', value: '04' },
{ label: '05 Property/Asset Sale', value: '05' },
{ label: '06 Inheritance', value: '06' },
{ label: '07 Other (Please specify)', value: '07' }
],
termsVisible: false,
termsAgreed: false,
canAgree: false,
applicationFormVisible: false,
currentStep: 1,
previewVisible: false,
previewData: null,
formData: {
username: '',
trustAccount: '',
Name: '',
gender: '',
title: '',
nationality: '',
idNumber: '',
phone: '',
phoneCode: '+852',
email: '',
address: '',
englishName: '',
idType: '',
idIssueDate: '',
idExpiryDate: '',
idAddress: '',
dateOfBirth: '',
occupation: '',
jobTitle: '',
yearsOfService: '',
yearlyIncome: '',
companyName: '',
officeAddress: '',
officeTel: '',
officeTelCode: '+852',
accountPurpose: '',
sourceOfWealth: '',
sourceOfWealthOther: '',
paymentPassword: '', // ✅ 主卡支付密码
paymentPassword2: '', // ✅ 新增：附属卡支付密码
busiWaterNo: '', // 🔹 后端返回的流水号
// 主卡证件上传
idDocFrontFileList: [],
idDocFrontUrl: '',
idDocFrontUrl_raw: null,
idDocBackFileList: [],
idDocBackUrl: '',
idDocBackUrl_raw: null,
idDocInfoFileList: [],
idDocInfoUrl: '',
idDocInfoUrl_raw: null,
// 主卡
cardName1: '',
cardType1: '',
showNameOnCard1: true,
showLogoOnCard1: true,
// 主卡签名
signatureData1: '',
isSigned1: false,
// 附属卡 1 (用于附属卡申请流程)
cardName2Chinese: '',
cardName2: '',
gender2: '',
nationality2: '',
idNumber2: '',
idType2: '',
dateOfBirth2: '',
idIssueDate2: '',
idExpiryDate2: '',
idAddress2: '',
phone2: '',
phoneCode2: '+852',
email2: '',
address2: '',
occupation2: '',
jobTitle2: '',
yearsOfService2: '',
yearlyIncome2: '',
companyName2: '',
officeAddress2: '',
officeTel2: '',
officeTelCode2: '+852',
accountPurpose2: '',
sourceOfWealth2: '',
sourceOfWealthOther2: '',
cardType2: '',
showNameOnCard2: true,
showLogoOnCard2: true,
creditLimit2: '',
idDocFrontFileList2: [],
idDocFrontUrl2: '',
idDocFrontUrl2_raw: null,
idDocBackFileList2: [],
idDocBackUrl2: '',
idDocBackUrl2_raw: null,
idDocInfoFileList2: [],
idDocInfoUrl2: '',
idDocInfoUrl2_raw: null,
// 附属卡 1 签名
signatureData2: '',
isSigned2: false,
allowedCards: []
},
cardTypeLabels: { gold: 'Gold Card', platinum: 'Platinum Card', black: 'Black Card' },
currentUserInfo: null
};
},
computed: {
availableCardTypes() {
const allCardOptions = [
{ value: 'gold', label: 'Gold Card', id: 1, visible: false },
{ value: 'platinum', label: 'Platinum Card', id: 2, visible: false },
{ value: 'black', label: 'Black Card', id: 3, visible: false }
];
const allowed = this.formData.allowedCards || [];
allCardOptions.forEach(option => {
option.visible = allowed.includes(option.id);
});
return allCardOptions;
}
},
methods: {
// 🔢 生成22位流水号（降级方案，当后端接口失败时使用）
generateSerial22() {
const ts = Date.now().toString().padStart(13, '0');
const rand = Math.random().toString(36).substring(2, 11).toUpperCase();
return (ts + rand).substring(0, 22).padEnd(22, 'X');
},
// 🔹 从后端获取流水号
async fetchSerialNumber() {
try {
const response = await axios.get('http://172.30.20.34:9190/internal/card/generate', {
timeout: 10000
});
if (response.data && response.data.code === 200) {
console.log('✅ Serial number fetched:', response.data.data);
return response.data.data;
} else {
console.warn('⚠️ Fetch serial number failed, fallback to local generation');
return this.generateSerial22();
}
} catch (error) {
console.error('❌ Error fetching serial number:', error);
return this.generateSerial22(); // 网络异常时使用本地生成
}
},
// ✅ 新增：处理英文名输入 - 只允许英文字母和空格，自动转大写
handleEnglishNameInput(value) {
if (!value) {
this.formData.englishName = '';
return;
}
// 只允许英文字母和空格，自动转大写，合并多个空格
this.formData.englishName = value
.replace(/[^a-zA-Z\s]/g, '')
.toUpperCase()
.replace(/\s{2,}/g, ' ')
.trim();
},
// ✅ 新增：处理签名组件的 input 事件
handleSignatureUpdate(index, value) {
this.formData[`signatureData${index}`] = value;
this.formData[`isSigned${index}`] = !!value && value.length > 100;
},
// ✅ 新增：清除签名（调用子组件方法）
clearSignature(index) {
const refName = `sigPad${index}`;
if (this.$refs[refName] && this.$refs[refName][0]) {
this.$refs[refName][0].clear();
}
},
// 🔹 辅助方法：国家名称转代码
getCountryCode(countryName) {
const country = this.countryList.find(c => c.name === countryName);
return country ? country.code : 'OTHER';
},
// 🔹 辅助方法：性别转代码
getSexCode(gender) {
return gender === 'male' ? 'M' : gender === 'female' ? 'F' : '';
},
// 🔹 辅助方法：证件类型转代码
getCertTypeCode(idType) {
const map = {
'MainlandID': '01',
'HKID': '02',
'Passport': '03',
'Other': '04'
};
return map[idType] || '04';
},
checkUrlToken() {
const query = this.$route?.query || {};
const testMode = query.test;
const token = query.token;
const callback = query.callback;
this.adminCallbackUrl = callback || '';
// if (testMode === 'uCFYP7pxXzXDSd5ubDKakwxK' && !token) {
if (testMode === 'uCFYP7pxXzXDSd5ubDKakwxK' && !token) {
console.log('🧪 Test mode enabled');
this.urlToken = 'mock_token_for_testing';
this.verifyToken(true);
return;
}
if (token) {
console.log('🔑 Token found:', token);
this.urlToken = token;
this.verifyToken(false);
return;
}
console.warn('⚠️ No token provided');
this.tokenValid = false;
this.loading = false;
this.$message.error('Access denied: Missing token parameter');
},
async verifyToken(isMock = false) {
try {
let response;
if (isMock) {
response = {
data: {
status: 1,
message: 'Token verified (mock)',
data: {
username: 'C123456',
name: '张三',
gender: 'male',
title: 'Mr.',
phone: '13800138000',
address: '123 Test Street, Hong Kong',
nationality: 'China',
idNumber: 'A123456(7)',
email: 'test@example.com',
allowedCards: [1, 2, 3]
}
}
};
await new Promise(resolve => setTimeout(resolve, 500));
} else {
response = await axios.post(
'http://172.30.20.33/new_hkt/api/misc/verify_token',
{ token: this.urlToken },
{
headers: { 'Content-Type': 'application/json' },
timeout: 10000
}
);
}
if (response.data && response.data.status === 1) {
this.tokenValid = true;
const userData = response.data.data;
this.formData.username = userData.username || '';
this.formData.trustAccount = userData.username || '';
this.formData.Name = userData.name || '';
this.formData.englishName = userData.name; // ✅ 自动填充拼音
this.formData.gender = userData.gender || '';
this.formData.title = userData.title || '';
this.formData.phone = userData.phone || '';
this.formData.address = userData.address || '';
this.formData.nationality = userData.nationality || '';
this.formData.idNumber = userData.idNumber || '';
this.formData.email = userData.email || '';
this.formData.allowedCards = Array.isArray(userData.allowedCards) ? userData.allowedCards : [];
this.currentUserInfo = userData;
this.$message.success('Token verified successfully!' + (isMock ? ' (Test Mode)' : ''));
this.cleanUrlToken();
} else {
this.tokenValid = false;
this.$message.error('Token verification failed: ' + (response.data.message || 'Invalid token'));
}
} catch (error) {
console.error('Token verification error:', error);
this.tokenValid = false;
if (error.response) {
this.$message.error(`API Error ${error.response.status}: ${error.response.data?.message || 'Verification failed'}`);
} else if (error.request) {
this.$message.error('Network error: Unable to connect to verification server');
} else {
this.$message.error('Token verification error. Please contact administrator.');
}
} finally {
this.loading = false;
}
},
cleanUrlToken() {
const cleanPath = window.location.pathname + window.location.hash.split('?')[0];
window.history.replaceState({}, document.title, cleanPath);
console.log('🧹 URL cleaned, token hidden from address bar');
if (this.$router?.currentRoute?.query?.token) {
this.$router.replace({
path: this.$route.path,
query: {
...this.$route.query,
token: undefined,
test: undefined,
callback: undefined
}
}).catch(() => {});
}
},
startApplication(type) {
if (!this.tokenValid) {
this.$message.error('Please verify token first');
return;
}
this.applicationType = type; // 设置申请类型
  
// 如果是附属卡申请，重置一些主卡特有的字段，避免混淆
if (type === 'supplementary') {
// 清空主卡相关的数据，防止残留
this.formData.cardName1 = '';
this.formData.cardType1 = '';
this.formData.signatureData1 = '';
this.formData.isSigned1 = false;

// 确保附属卡字段干净
this.formData.cardName2 = '';
this.formData.cardType2 = '';
this.formData.creditLimit2 = '';
this.formData.paymentPassword2 = ''; // ✅ 清空副卡密码
this.formData.signatureData2 = '';
this.formData.isSigned2 = false;

// 注意：formData.Name 等基础信息在附属卡模式下是供用户填写的“附属卡持有人”信息
// 所以不需要清空 Name, englishName 等，让用户重新填
} else {
// 主卡申请，加载客户数据
if (this.currentUserInfo) {
this.loadCustomerData();
}
}

this.openTermsDialog();
},
async openTermsDialog() {
this.termsVisible = true;
this.termsAgreed = false;
this.canAgree = false;
this.$nextTick(() => {
if (this.$refs.termsContentRef) this.$refs.termsContentRef.scrollTop = 0;
});

// 只有主卡申请时才自动加载客户数据填充只读字段
if (this.applicationType === 'primary' && this.currentUserInfo) {
this.loadCustomerData();
} else if (this.applicationType === 'supplementary') {
// 附属卡申请时，清空基础信息以便用户输入附属卡持有人信息
// 但保留 username (trust account) 因为这是关联的主账户
const currentTrustAccount = this.formData.username; 
this.resetFormDataForSupplementary();
this.formData.username = currentTrustAccount; // 恢复信托账号
this.formData.trustAccount = currentTrustAccount;
}

// 获取并填充流水号
const serialNo = await this.fetchSerialNumber();
this.formData.busiWaterNo = serialNo;
},

// 新增辅助方法：重置表单以用于附属卡填写
resetFormDataForSupplementary() {
// 保留 username, trustAccount, allowedCards
const preserved = {
username: this.formData.username,
trustAccount: this.formData.trustAccount,
allowedCards: this.formData.allowedCards
};

// 重置其他所有字段为空
this.$data.formData = {
...this.$options.data().formData, // 获取初始默认值
...preserved // 恢复保留字段
};
},

closeTermsDialog() {
this.termsVisible = false;
this.termsAgreed = false;
this.canAgree = false;
},
handleTermsScroll(event) {
const el = event.target;
this.canAgree = (el.scrollHeight - el.scrollTop <= el.clientHeight + 5);
},
acceptTerms() {
if (this.termsAgreed) {
this.termsVisible = false;
this.applicationFormVisible = true;
this.currentStep = 1;
}
},
loadCustomerData() {
if (this.currentUserInfo) {
const info = this.currentUserInfo;
this.formData.username = info.username || '';
this.formData.trustAccount = info.username || '';
this.formData.Name = info.name || '';
this.formData.englishName = info.englishName;
this.formData.title = info.title || '';
this.formData.gender = info.gender || '';
this.formData.phone = info.phone || '';
this.formData.address = info.address || '';
this.formData.nationality = info.nationality || '';
this.formData.idNumber = info.idNumber || '';
this.formData.email = info.email || '';
this.formData.allowedCards = Array.isArray(info.allowedCards) ? info.allowedCards : [];
}
},
// 🔹 核心修改：只要不是大陆身份证，到期时间默认 9999-12-31
handleIdTypeChange() {
this.formData.idDocFrontFileList = [];
this.formData.idDocBackFileList = [];
this.formData.idDocInfoFileList = [];
this.formData.idDocFrontUrl = '';
this.formData.idDocBackUrl = '';
this.formData.idDocInfoUrl = '';
this.formData.idDocFrontUrl_raw = null;
this.formData.idDocBackUrl_raw = null;
this.formData.idDocInfoUrl_raw = null;
if (this.formData.idType === 'MainlandID') {
this.formData.idExpiryDate = ''; // 大陆身份证需要用户选择
} else {
this.formData.idExpiryDate = '9999-12-31'; // 其他所有类型默认长期
}
},
handlePurposeChange() {
if (this.formData.accountPurpose !== '99') {}
},
handleWealthChange() {
if (this.formData.sourceOfWealth !== '07') {
this.formData.sourceOfWealthOther = '';
}
},
handleIdUpload(file, targetUrlField, targetFileList) {
console.log('📁 File selected:', file.name, file.size, file.raw?.type);
const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
const fileType = file.raw?.type || file.type;
const isAllowedType = allowedTypes.includes(fileType);
if (!isAllowedType) {
this.$message.error('Supports JPG, PNG, or PDF formats only');
this.formData[targetFileList] = [];
this.$set(this.formData, targetUrlField, '');
this.$set(this.formData, targetUrlField + '_raw', null);
return false;
}
const limitSize = 5 * 1024 * 1024;
const fileSize = file.size || file.raw?.size || 0;
if (fileSize > limitSize) {
this.$message.error('File size must not exceed 5MB!');
this.formData[targetFileList] = [];
this.$set(this.formData, targetUrlField, '');
this.$set(this.formData, targetUrlField + '_raw', null);
return false;
}
const fileObj = {
name: file.name || file.raw?.name || 'uploaded_file',
size: fileSize,
type: fileType,
status: 'ready',
uid: Date.now() + Math.random()
};
this.$set(this.formData, targetUrlField + '_raw', file.raw || file);
this.$set(this.formData, targetFileList, [fileObj]);
this.$message.success('File selected successfully. Will upload on final submission.');
this.$forceUpdate();
return false;
},
handlePhoneInput(cardIndex, value) {
const cleanValue = value.replace(/\D/g, '');
if (cardIndex === 1) {
this.$set(this.formData, 'phone', cleanValue);
}
},
// ✅ 修改：英文名输入校验 - 只允许英文字母和空格，自动转大写
sanitizeEnglishName(name) {
if (!name) return '';
// 只允许英文字母和空格，自动转大写，合并多个空格
return name
.replace(/[^a-zA-Z\s]/g, '')
.toUpperCase()
.replace(/\s{2,}/g, ' ')
.trim();
},
handleCardName1Input(value) { this.formData.cardName1 = this.sanitizeEnglishName(value); },
handleCardName2Input(value) { this.formData.cardName2 = this.sanitizeEnglishName(value); },
nextStep() {
if (this.currentStep === 1) {
// 通用验证：英文名、ID类型、生日、职业等
if (!this.formData.englishName || !this.formData.idType || !this.formData.dateOfBirth || !this.formData.occupation) {
this.$message.warning('Please complete all required fields in Step 1');
return;
}

// 证件上传验证
if (this.formData.idType === 'MainlandID') {
const hasFront = this.formData.idDocFrontUrl_raw || (this.formData.idDocFrontFileList?.length > 0);
const hasBack = this.formData.idDocBackUrl_raw || (this.formData.idDocBackFileList?.length > 0);
if (!hasFront || !hasBack) {
this.$message.warning('Please upload both front and back of your ID');
return;
}
} else {
const hasInfo = this.formData.idDocInfoUrl_raw || (this.formData.idDocInfoFileList?.length > 0);
if (!hasInfo) {
this.$message.warning('Please upload your ID/Passport information page');
return;
}
}

// 如果是主卡，验证支付密码
if (this.applicationType === 'primary' && !this.formData.paymentPassword) {
this.$message.warning('Please set a payment password');
return;
}
}

if (this.currentStep < 2) this.currentStep++;
},
prevStep() { if (this.currentStep > 1) this.currentStep--; },
getCharCountClass(len) {
if (len > 20) return 'error';
if (len > 15) return 'warning';
return '';
},
getCardImage(type, showLogo = true) {
if (type === 'gold') {
return showLogo
? require('@/assets/gold-card-with-logo.png')
: require('@/assets/gold-card-no-logo.png');
}
if (type === 'platinum') {
return showLogo
? require('@/assets/platinum-card-with-logo.png')
: require('@/assets/platinum-card-no-logo.png');
}
if (type === 'black') {
return showLogo
? require('@/assets/black-card-with-logo.png')
: require('@/assets/black-card-no-logo.png');
}
return require('@/assets/gold-card.png');
},
boolToText(val) { return val ? 'Yes' : 'No'; },
submitApplication() {
// 1. 基础验证
if (this.applicationType === 'primary') {
if (!this.formData.cardType1) {
this.$message.warning('Please select the card type.');
return;
}
if (!this.formData.isSigned1) {
this.$message.warning('Primary cardholder signature is required');
return;
}
// 主卡提交前，确保 cardName1 有值，通常等于 englishName
if (!this.formData.cardName1) {
this.formData.cardName1 = this.formData.englishName;
}
// ✅ 验证主卡密码
if (!this.formData.paymentPassword || this.formData.paymentPassword.length !== 6) {
   this.$message.warning('Please enter a valid 6-digit payment password for Primary Card');
   return;
}
} 

if (this.applicationType === 'supplementary') {
if (!this.formData.cardType2) {
this.$message.warning('Please select the card type for supplementary card.');
return;
}
if (!this.formData.isSigned2) {
this.$message.warning('Supplementary cardholder signature is required');
return;
}
if (!this.formData.creditLimit2) {
this.$message.warning('Please set credit limit for supplementary card');
return;
}
// ✅ 新增：验证副卡密码
if (!this.formData.paymentPassword2 || this.formData.paymentPassword2.length !== 6) {
   this.$message.warning('Please enter a valid 6-digit payment password for Supplementary Card');
   return;
}
// 确保 cardName2 有值
if (!this.formData.cardName2) {
this.formData.cardName2 = this.formData.englishName;
}
}

// 进入预览
this.previewData = { ...this.formData, applicationType: this.applicationType };
this.previewVisible = true;
},
async confirmAndSubmit() {
const loading = this.$loading({
lock: true,
text: 'Processing: Uploading attachments & submitting form...',
background: 'rgba(0,0,0,0.7)'
});

try {
// 1. 上传附件 (逻辑保持不变，根据 rawData 上传)
const uploadPromises = [];
const uploadResults = {};

// ========== 主申请人/附属卡持有人证件上传 ==========
// 注意：无论是主卡还是附属卡申请，Step 1 填写的都是当前申请人的证件，所以都上传到主字段
if (this.formData.idDocFrontUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocFrontUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ ID Front Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocFrontUrl = res.data.url;
uploadResults.idDocFrontUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('ID Front Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ ID Front Upload Error:', err);
if (err.response) {
throw new Error('ID Front Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('ID Front Upload Failed (Network Timeout)');
} else {
throw new Error('ID Front Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocBackUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocBackUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ ID Back Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocBackUrl = res.data.url;
uploadResults.idDocBackUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('ID Back Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ ID Back Upload Error:', err);
if (err.response) {
throw new Error('ID Back Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('ID Back Upload Failed (Network Timeout)');
} else {
throw new Error('ID Back Upload Failed: ' + err.message);
}
})
);
}
if (this.formData.idDocInfoUrl_raw) {
const fd = new FormData();
fd.append('file', this.formData.idDocInfoUrl_raw);
uploadPromises.push(
axios.post('https://htkcmvisa.giize.com/upload_id_doc.php', fd, {
headers: { 'Content-Type': 'multipart/form-data' },
timeout: 30000
}).then(res => {
console.log('✅ ID Info Page Upload Response:', res.data);
if (res.data && res.data.status === 1) {
this.formData.idDocInfoUrl = res.data.url;
uploadResults.idDocInfoUrl = res.data.url;
} else {
const errMsg = res.data?.message || 'Unknown error';
throw new Error('ID Info Page Upload Failed: ' + errMsg);
}
}).catch(err => {
console.error('❌ ID Info Page Upload Error:', err);
if (err.response) {
throw new Error('ID Info Page Upload Failed (Server): ' + (err.response.data?.message || 'Backend error'));
} else if (err.request) {
throw new Error('ID Info Page Upload Failed (Network Timeout)');
} else {
throw new Error('ID Info Page Upload Failed: ' + err.message);
}
})
);
}

if (uploadPromises.length > 0) {
console.log('📤 Starting upload of', uploadPromises.length, 'files...');
await Promise.all(uploadPromises);
console.log('✅ All files uploaded', uploadResults);
}

// 2. 组装提交数据
let postData = {};

if (this.applicationType === 'primary') {
// === 主卡提交数据组装 ===
postData = {
address: this.formData.address || '',
agent: 'HKTCM',
agentRegion: 'HK',
birthday: this.formData.dateOfBirth || '',
busiWaterNo: this.formData.busiWaterNo || this.generateSerial22(),
cardName: this.formData.cardName1 || '',
cardNo: '',
cardType: this.formData.cardType1 || '',
certEndDate: this.formData.idExpiryDate || '9999-12-31',
certId: this.formData.idNumber || '',
certStartDate: this.formData.idIssueDate || '',
certType: this.getCertTypeCode(this.formData.idType),
companyName: this.formData.companyName || '',
country: this.getCountryCode(this.formData.nationality),
email: this.formData.email || '',
groupId: '',
id: '',
idAddress: this.formData.idAddress || '',
idDocBackUrl: this.formData.idDocBackUrl || '',
idDocFrontUrl: this.formData.idDocFrontUrl || '',
idDocInfoUrl: this.formData.idDocInfoUrl || '',
mobNo: this.formData.phone || '',
mobNoOf: (this.formData.phoneCode || '+852').replace('+', ''),
name: this.formData.Name || '',
nameEn: this.formData.englishName || '',
officeAddress: this.formData.officeAddress || '',
officeTel: this.formData.officeTel || '',
officeTelCode: (this.formData.officeTelCode || '+852').replace('+', ''),

// ✅ 修改：直接使用明文密码，移除 this.md5()
payPwd: this.formData.paymentPassword || '', 

position: this.formData.jobTitle || '1',
profession: this.formData.occupation || '999',
professionOther: '',
purpose: this.formData.accountPurpose || '01',
purposeOther: '',
sex: this.getSexCode(this.formData.gender),
showLogoOnCard: this.formData.showLogoOnCard1 ? 'Y' : 'N',
showNameOnCard: this.formData.showNameOnCard1 ? 'Y' : 'N',
trustAccount: this.formData.username || '',
wealthSource: this.formData.sourceOfWealth || '01',
wealthSourceOther: '',
yearlyIncome: this.formData.yearlyIncome ? parseInt(this.formData.yearlyIncome) : 0,
yearsOfService: this.formData.yearsOfService || '',
// 标记这是主卡申请
appType: 'PRIMARY' 
};
} else {
// === 附属卡提交数据组装 ===
// 注意：附属卡通常需要关联主卡信托账号，并且提交的是附属卡持有人的信息
postData = {
address: this.formData.address || '', // 附属卡持有人地址
agent: 'HKTCM',
agentRegion: 'HK',
birthday: this.formData.dateOfBirth || '', // 附属卡持有人生日
busiWaterNo: this.formData.busiWaterNo || this.generateSerial22(),
cardName: this.formData.cardName2 || '', // 附属卡姓名
cardNo: '',
cardType: this.formData.cardType2 || '', // 附属卡卡种
certEndDate: this.formData.idExpiryDate || '9999-12-31',
certId: this.formData.idNumber || '', // 附属卡持有人证件号
certStartDate: this.formData.idIssueDate || '',
certType: this.getCertTypeCode(this.formData.idType),
companyName: this.formData.companyName || '',
country: this.getCountryCode(this.formData.nationality),
email: this.formData.email || '',
groupId: '',
id: '',
idAddress: this.formData.idAddress || '',
idDocBackUrl: this.formData.idDocBackUrl || '', // 附属卡证件照
idDocFrontUrl: this.formData.idDocFrontUrl || '',
idDocInfoUrl: this.formData.idDocInfoUrl || '',
mobNo: this.formData.phone || '',
mobNoOf: (this.formData.phoneCode || '+852').replace('+', ''),
name: this.formData.Name || '', // 附属卡持有人法定姓名
nameEn: this.formData.englishName || '',
officeAddress: this.formData.officeAddress || '',
officeTel: this.formData.officeTel || '',
officeTelCode: (this.formData.officeTelCode || '+852').replace('+', ''),

// ✅ 新增：附属卡明文密码
payPwd: this.formData.paymentPassword2 || '', 

position: this.formData.jobTitle || '1',
profession: this.formData.occupation || '999',
professionOther: '',
purpose: this.formData.accountPurpose || '01',
purposeOther: '',
sex: this.getSexCode(this.formData.gender),
showLogoOnCard: this.formData.showLogoOnCard2 ? 'Y' : 'N',
showNameOnCard: this.formData.showNameOnCard2 ? 'Y' : 'N',
trustAccount: this.formData.username || '', // 关联的主信托账号
wealthSource: this.formData.sourceOfWealth || '01',
wealthSourceOther: '',
yearlyIncome: this.formData.yearlyIncome ? parseInt(this.formData.yearlyIncome) : 0,
yearsOfService: this.formData.yearsOfService || '',
// 附属卡特有字段：额度
creditLimit: this.formData.creditLimit2 || '0',
// 标记这是附属卡申请
appType: 'SUPPLEMENTARY'
};
}

console.log('📤 Submitting to new API:', postData);

// 3. 调用接口
const res = await axios.post(
'https://htkcmvisa.giize.com/submit_application_table.php',
postData,
{
headers: { 'Content-Type': 'application/json' },
timeout: 30000
}
);

if (res.data && res.data.code === 200) {
this.$message.success('Your application has been successfully submitted!');
this.previewVisible = false;
this.applicationFormVisible = false;

if (this.adminCallbackUrl && res.data.data?.applicationId) {
this.notifyAdminCallback(res.data.data.applicationId);
}
} else {
this.$message.error('Submission failed: ' + (res.data.msg || 'Unknown error'));
}
} catch (error) {
console.error('❌ Submission Error:', error);
const userMsg = error.response?.data?.msg || error.message || 'System error: Submission failed';
this.$message.error(userMsg);
} finally {
loading.close();
}
},
async notifyAdminCallback(applicationId) {
try {
await axios.post(this.adminCallbackUrl, {
token: this.urlToken,
applicationId: applicationId,
status: 'submitted',
submitTime: new Date().toISOString()
});
console.log('Admin callback successful');
} catch (error) {
console.error('Admin callback failed:', error);
}
},
goHome() {
window.history.pushState({}, document.title, window.location.pathname);
this.urlToken = '';
this.tokenValid = false;
}
},
mounted() {
this.checkUrlToken();
}
};
</script>

<style>
:root {
--bg-light: #f8f9fc;
--primary-color: #1E3A8A;
--accent-color: #F59E0B;
--border-color: #e2e8f0;
--text-primary: #1E293B;
--text-secondary: #64748B;
--text-error: #EF4444;
--bg-white: #fff;
--bg-gray: #f8f9fa;
}
body, html { margin: 0; padding: 0; height: 100%; font-family: -apple-system, 'Helvetica Neue', Arial, sans-serif; background-color: var(--bg-light); overflow: hidden; }
.app-wrapper { display: flex; height: 100vh; }
.access-denied { display: flex; justify-content: center; align-items: center; min-height: 100vh; background: #f8f9fc; width: 100%; }
.denied-content { text-align: center; padding: 40px; background: white; border-radius: 12px; box-shadow: 0 4px 12px rgba(0,0,0,0.1); }
.denied-content h1 { color: #EF4444; margin-bottom: 20px; }
.denied-content p { color: #64748B; margin-bottom: 30px; }
.loading-overlay { display: flex; justify-content: center; align-items: center; height: 100vh; background: #f8f9fc; width: 100%; }
.loading-content { text-align: center; }
.loading-content p { margin-top: 15px; color: var(--text-secondary); }
.main-wrapper { flex: 1; display: flex; flex-direction: column; overflow: hidden; position: relative; }
.content-main { flex: 1; padding: 25px; overflow-y: auto; }
.apply-section { background: white; border-radius: 12px; padding: 25px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); margin-top: 20px; }
.apply-item { display: flex; justify-content: space-between; align-items: center; padding: 20px 0; border-bottom: 1px solid #eee; }
.apply-item:last-child { border-bottom: none; }
.apply-info { flex: 1; text-align: left; }
.apply-title { font-weight: bold; font-size: 16px; color: #333; margin-bottom: 5px; }
.apply-desc { font-size: 14px; color: #666; }
.apply-btn { min-width: 120px; padding: 10px 20px; border-radius: 8px; font-weight: 500; cursor: pointer; text-align: center; transition: all 0.3s ease; }
.apply-btn-primary { background-color: var(--primary-color); color: white; border: 1px solid var(--primary-color); }
.apply-btn-primary:hover { background-color: #3B82F6; border-color: #3B82F6; }
.apply-btn-secondary { background-color: white; color: var(--primary-color); border: 1px solid var(--primary-color); }
.apply-btn-secondary:hover { background-color: #eff6ff; }
.terms-dialog .el-dialog__body { padding: 0; overflow: hidden; }
.terms-header { padding: 20px 30px; background: var(--bg-gray); border-bottom: 1px solid var(--border-color); font-weight: bold; text-align: center; color: var(--primary-color); }
.terms-content { padding: 30px; max-height: 50vh; overflow-y: auto; line-height: 1.8; font-size: 14px; color: var(--text-primary); text-align: left; }
.terms-footer { padding: 20px 30px; background: var(--bg-gray); border-top: 1px solid var(--border-color); display: flex; align-items: center; justify-content: space-between; }
.terms-checkbox { display: flex; align-items: flex-start; gap: 8px; }
.terms-checkbox input[type="checkbox"] { margin-top: 3px; }
.terms-checkbox-label { font-size: 11px; color: var(--text-secondary); }
.terms-checkbox-label span { color: var(--text-error); }
.terms-actions { display: flex; gap: 10px; }
.terms-cancel { flex: 1; background: white; border: 1px solid #ddd; color: var(--text-secondary); }
.terms-accept { flex: 1; background: var(--primary-color); border: none; color: white; }
.terms-accept:disabled { background: #93c5fd; cursor: not-allowed; }
.application-form-dialog .el-dialog { width: 1400px !important; max-width: 95vw; }
.application-form-dialog .el-dialog__body { padding: 30px; background: var(--bg-white); max-height: 80vh; overflow-y: auto; }
.form-section { margin-bottom: 30px; padding-bottom: 20px; border-bottom: 1px solid var(--border-color); }
.section-title { font-size: 18px; font-weight: bold; color: var(--primary-color); margin-bottom: 20px; display: flex; align-items: center; }
.section-title::before { content: ''; display: inline-block; width: 4px; height: 20px; background: var(--accent-color); margin-right: 10px; border-radius: 2px; }
.form-group-title { font-size: 16px; font-weight: 600; color: var(--text-primary); margin-top: 10px; border-left: 3px solid var(--primary-color); padding-left: 10px; }
.part-a-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 20px; }
.form-group { display: flex; flex-direction: column; }
.form-label { font-size: 14px; font-weight: 500; color: var(--text-primary); margin-bottom: 6px; }
.form-input { padding: 10px 12px; border: 1px solid var(--border-color); border-radius: 4px; font-size: 14px; color: var(--text-primary); transition: border-color 0.2s; }
.form-input:focus { outline: none; border-color: var(--primary-color); box-shadow: 0 0 0 2px rgba(30, 58, 138, 0.1); }
.large-input { width: 100%; min-height: 40px; padding: 10px 12px; }
.readonly-input { background-color: #f5f7fa !important; color: #6c757d; cursor: not-allowed; border-color: #e2e8f0; }
.required-input { border-left: 3px solid var(--accent-color); }
.upload-component { width: 100%; }
.card-preview { position: relative; width: 400px; height: 250px; margin-top: 15px; border-radius: 15px; overflow: hidden; box-shadow: 0 10px 20px rgba(0,0,0,0.2); }
.card-preview img { width: 100%; height: 100%; object-fit: cover; position: absolute; top: 0; left: 0; z-index: 1; }
.card-preview .logo-overlay { position: absolute; top: 40px; left: 50%; transform: translateX(-50%); height: 40px; width: auto; z-index: 2; }
.card-preview .name-overlay { position: absolute; top: 87%; left: 30px; transform: translateY(-50%); color: white; font-family: 'OCR A Std', monospace, sans-serif; font-size: 0.9rem; text-transform: uppercase; text-shadow: 1px 1px 2px rgba(0,0,0,0.6); z-index: 2; }
.preview-table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
.preview-table th, .preview-table td { border: 1px solid var(--border-color); padding: 8px 12px; vertical-align: top; text-align: left; }
.preview-table th { width: 30%; background-color: #f5f7fa; font-weight: bold; }
.step-nav { display: flex; justify-content: center; margin: 20px 0 30px; gap: 30px; }
.step { display: flex; flex-direction: column; align-items: center; gap: 5px; }
.step-number { width: 30px; height: 30px; border-radius: 50%; background: #CBD5E1; color: #475569; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 14px; }
.step-number.active { background: var(--primary-color); color: white; }
.step-label { font-size: 12px; color: var(--text-secondary); }
.step-label.active { color: var(--primary-color); font-weight: 500; }
.step-connector { width: 50px; height: 2px; background: #CBD5E1; align-self: center; }
.step-connector.active { background: var(--primary-color); }
.form-footer { display: flex; justify-content: space-between; margin-top: 30px; padding-top: 20px; border-top: 1px solid var(--border-color); }
.form-btn { padding: 10px 24px; border-radius: 6px; font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s; border: none; }
.btn-prev { background: #F1F5F9; color: var(--text-primary); }
.btn-prev:hover { background: #E2E8F0; }
.btn-next, .btn-submit { background: var(--primary-color); color: white; }
.btn-next:hover, .btn-submit:hover { background: #3B82F6; }
@media (max-width: 768px) { .part-a-grid { grid-template-columns: 1fr; } }
</style>